import { autoinject, transient } from "aurelia-framework";
import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from "../../../../../models/basics/basics.models";
import { CrewWelfareSearchToolService } from "../../../../../services/vetting/cwsa-search-tool.service";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../../configuration/rightshipqi-router.constants";

@autoinject()
@transient()
export class SelfAssessment {
    public entityTypes: EntityTypeConfigurationModel[];    
    private token: string;
    protected isExpiredDateCWSA: boolean;
    public entityName: string;
    public validityExpireDate?: Date;
    public valid: number = -1;

    constructor(private entityTypeConfigurationHelper: EntityTypeConfigurationHelper,
        public crewWelfareService: CrewWelfareSearchToolService,
        private router: Router) {
        this.entityTypes = this.entityTypeConfigurationHelper.getConfigurationByKey(["InformativeVesselSearch", "InformativeCompanySearch"]);
    }

    activate(params) {
        if (!params) {
            this.router.navigateToRoute(RightShipQiRouterConstants.CrewWelfareSearchToolRouteNames.RequestCrewWelfareSearchTool, { replace: true, trigger: true });
        }
        this.token = params.id;
        this.crewWelfareService.checkExpiryDateCWSAClientSearchTook({ token: this.token }).then((res) => {
            if (!res) {
                const referrer = { referrer: location.href }
                this.isExpiredDateCWSA = true;
                this.router.navigateToRoute(RightShipQiRouterConstants.CrewWelfareSearchToolRouteNames.RequestCrewWelfareSearchTool, referrer, { replace: true, trigger: true });
            } else {
                this.isExpiredDateCWSA = false;
            }
        }
        );
    }

    searchItemSelected(e: any) {
        const detail = e.detail;
        if (detail && detail.selectedEntityUri && detail.selectedEntity) {
            const entityType = detail.selectedEntityUri;
            const encryptedId = detail.selectedEntity.encryptedId;
            this.entityName = entityType == "CompanySearch" ? detail.selectedEntity.fullName: detail.selectedEntity.name;            
            this.valid = -1;
            this.crewWelfareService.checkCWStatusByDOCCompanyOrVessel(encryptedId, entityType).then(x => {
                if (x != null) {
                    this.validityExpireDate = x.validityExpireDate;
                    if(x.crewWelfareStatus == "Not Submitted") this.valid = 0; //Not Done
                    else if(x.crewWelfareStatus == "Submitted") this.valid = 1; //Valid
                    else this.valid = 2;//Expired
                }else{
                    this.valid = 0; //Not Done
                }
            });
        }
    }
}